var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 20c5.47 0 10-4.54 10-10C20 4.53 15.46 0 9.99 0 4.53 0 0 4.53 0 10c0 5.46 4.54 10 10 10m0-1.667A8.293 8.293 0 0 1 1.676 10c0-4.627 3.687-8.333 8.314-8.333A8.316 8.316 0 0 1 18.333 10 8.295 8.295 0 0 1 10 18.333m-4.578-6.902a1.431 1.431 0 0 0 0-2.862c-.795 0-1.432.647-1.432 1.431s.637 1.431 1.432 1.431m4.568 0A1.44 1.44 0 0 0 11.422 10 1.44 1.44 0 0 0 9.99 8.569 1.44 1.44 0 0 0 8.56 10a1.44 1.44 0 0 0 1.431 1.431m4.579 0a1.431 1.431 0 0 0 0-2.862c-.795 0-1.432.647-1.432 1.431s.637 1.431 1.432 1.431"
  })));
};
export default SvgMore;